import createAsyncSlice from '../utils/createAsyncSlice';

const warehouse = createAsyncSlice({
  name: 'warehouse',
  initialState: {
    data: [],
  },
});

export const fetchWarehouse = warehouse.asyncAction;
export const httpRequestWarehouse = warehouse.httpRequest;
export const { resetState: resetWarehouseState } = warehouse.actions;
export default warehouse.reducer;
